import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';

import { TourEvent } from './project-tour-ontour-event.entity';

export type TourTravel = {
  id: number;
  sequenceId: number;
  name: string;
  connexionTypeWithEvent: TourTravelConnexionTypeWithEvent;
  travelDistance: number;
  fromEventId: TourEvent['id'] | undefined;
  fromPosition: PositionGeocode | undefined;
  toEventId: TourEvent['id'] | undefined;
  toPosition: PositionGeocode | undefined;
};

export type TourTravelConnexionTypeWithEvent =
  (typeof TourTravelConnexionTypeWithEventValues)[number];

export const TourTravelConnexionTypeWithEventValues = [
  'incoming',
  'direct',
  'outgoing',
] as const;
